export const CONTENT_TYPE_RESULTS = 'results';

export const divestitureRoute = `/projects/:projectId/divestiture-diagnostic`;
export const resultsRoute = `${divestitureRoute}/${CONTENT_TYPE_RESULTS}`;
export const categoryPathRoute = `${resultsRoute}/:categoryPath`;

export const formatDivestitureRoute = (projectId) =>
  divestitureRoute.replace(':projectId', projectId);

export const formatResultsRoute = (projectId) =>
  resultsRoute.replace(':projectId', projectId);

export const formatCategoryPathRoute = (projectId, categoryPath) =>
  categoryPathRoute
    .replace(':projectId', projectId)
    .replace(':categoryPath', categoryPath);
